


































import Moment from "moment";
import { Component, Mixins, Prop, } from "vue-property-decorator";
import { ReceptionComment } from "../../../../domain/workflow/reception";
import { ModelEditableMixin } from "../../../system/mixins";

export interface IConflictCommentEditor {
  focus(): void;
  setSelectionRange(start: number, end: number, direction?: "forward" | "backward" | "none"): void;
}

export function instanceOfIConflictCommentEditor(instance: any): instance is IConflictCommentEditor {
  return instance
    && (typeof instance.focus === "function")
    && (typeof instance.setSelectionRange === "function");
}

@Component
export default class ConflictCommentEditor extends Mixins(ModelEditableMixin) implements IConflictCommentEditor {
  @Prop()
  commentLabel: string;

  @Prop()
  latestReceptionComment: ReceptionComment;

  @Prop({ default: false })
  isEditOnly: boolean;

  @Prop({ default: false })
  isDeleted: boolean;

  get description(): string {
    return this.isDeleted
      ? this.deletedMessage
      : this.message;
  }

  get message(): string {
    return "既に他のユーザによって" + this.commentLabel
      + "が更新されています。更新された内容をご確認の上、必要でしたら" + this.commentLabel
      + (this.isEditOnly ? "の内容を変更してください。" : "の内容を変更して、再度保存してください。（保存すると上書きされます。）");
  }

  get deletedMessage(): string {
    return "既に他のユーザによって" + this.commentLabel
      + "が削除されています。新規で作成する場合は保存を押してください。";
  }

  get latestCommentHeader(): string {
    return "最新の" + this.commentLabel;
  }

  get latestCommentCreateUserName(): string {
    return this.latestReceptionComment && this.latestReceptionComment.createUser
      ? this.latestReceptionComment.createUser.name
      : "";
  }

  get latestCommentUpdateDateTime(): string {
    return this.latestReceptionComment && this.latestReceptionComment.updateDateTime
      ? Moment(this.latestReceptionComment.updateDateTime).format("YY/MM/DD HH:mm")
      : "";
  }

  get latestCommentContent(): string {
    return this.latestReceptionComment
      ? this.latestReceptionComment.content
      : "";
  }

  get editingCommentHeader(): string {
    return "編集中の" + this.commentLabel;
  }

  clearEditingComment(): void {
    this.editingSource = "";
    this.focus();
  }

  focus(): void {
    const textarea = this.$refs.textarea as HTMLTextAreaElement;
    textarea.focus();
  }

  setSelectionRange(start: number, end: number, direction?: "forward" | "backward" | "none"): void {
    const textarea = this.$refs.textarea as HTMLTextAreaElement;
    textarea.setSelectionRange(start, end, direction);
  }

  dragOver(event: DragEvent): void {
    event.stopPropagation();
    event.dataTransfer.effectAllowed = "copy";
  }

  contextmenu(e: PointerEvent) {
    this.$showTextInputContextMenu(e);
  }
}
